"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Table = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactTable = require("react-table");
var _TableBody = require("./TableBody/TableBody");
var _TableControls = require("./TableUtilities/TableControls");
var _AddRowSelectColumn = require("./TableUtilities/AddRowSelectColumn");
var _TableFilterTypes = require("./TableFilters/TableFilterTypes");
var _StandardTableCell = require("./TableCells/StandardTableCell");
var _InlineEditableCell = require("./TableCells/InlineEditableCell");
var _TextColumnFilter = require("./TableFilters/TextColumnFilter");
var _TableHead = require("./TableHead/TableHead");
var _TablePaginator = require("./TablePagination/TablePaginator");
var _TableProps = require("./TableProps");
require("./tables.scss");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Table = _ref => {
  let {
    tableId,
    columns,
    data,
    hookFormMethods,
    isEditable = false,
    customFooter = null,
    isInitialised,
    inlineEditing,
    pageSize = 10,
    showRowSelectors = false,
    enableGrouping = false,
    onEditHandler,
    onDeleteHandler,
    onInitHandler,
    onUpdateHandler,
    onSaveHandler,
    onResetHandler,
    skipReset
  } = _ref;
  const filterTypes = (0, _react.useMemo)(_TableFilterTypes.TableFilterTypes, []);
  const defaultColumn = (0, _react.useMemo)(() => {
    if (isEditable && inlineEditing) {
      return {
        Filter: _TextColumnFilter.TextColumnFilter,
        Cell: _InlineEditableCell.InlineEditableCell
      };
    }
    return {
      Filter: _TextColumnFilter.TextColumnFilter,
      Cell: _StandardTableCell.StandardTableCell
    };
  }, [isEditable, inlineEditing]);
  const tableInstance = (0, _reactTable.useTable)({
    columns,
    data,
    initialState: {
      pageIndex: 0,
      pageSize
    },
    defaultColumn,
    filterTypes,
    autoResetPage: !skipReset,
    // Pass this so the page doesn't change when the data is edited.
    autoResetSelectedRows: !skipReset,
    disableMultiSort: true,
    onEditHandler,
    onSaveHandler,
    onDeleteHandler,
    onUpdateHandler,
    onResetHandler
  }, _reactTable.useFilters, _reactTable.useGroupBy, _reactTable.useSortBy, _reactTable.useExpanded, _reactTable.usePagination, _reactTable.useRowSelect, _reactTable.useRowState, hooks => {
    if (showRowSelectors) {
      (0, _AddRowSelectColumn.AddRowSelectColumn)({
        hooks,
        tableId
      });
    }
  });
  const HandleEditing = _ref2 => {
    let {
      index,
      id,
      newValue
    } = _ref2;
    onEditHandler({
      rowIndex: index,
      fieldId: id,
      newValue
    });
  };
  (0, _react.useEffect)(() => {
    if (!isInitialised) {
      onInitHandler(tableInstance);
    }
  }, [isInitialised, onInitHandler, tableInstance]);
  if (isEditable && (!isInitialised || !tableInstance)) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "petSureTable"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "petSureTable-scroller"
  }, /*#__PURE__*/_react.default.createElement("table", tableInstance.getTableProps(), /*#__PURE__*/_react.default.createElement(_TableHead.TableHead, {
    enableGrouping: enableGrouping,
    hasSelectorColumn: showRowSelectors,
    headerGroups: tableInstance.headerGroups,
    isEditable: isEditable,
    inlineEditing: inlineEditing
  }), /*#__PURE__*/_react.default.createElement(_TableBody.TableBody, {
    tableInstance: tableInstance,
    hookFormMethods: hookFormMethods,
    isEditable: isEditable,
    inlineEditing: inlineEditing,
    showRowEditingControls: showRowSelectors && isEditable && !inlineEditing,
    onDelete: onDeleteHandler,
    onEdit: HandleEditing
  }))), customFooter ? /*#__PURE__*/_react.default.createElement("div", {
    className: "tableFooter"
  }, customFooter) : /*#__PURE__*/_react.default.createElement("div", {
    className: "tableFooter"
  }, /*#__PURE__*/_react.default.createElement(_TablePaginator.TablePaginator, {
    tableInstance: tableInstance,
    totalNumberRows: tableInstance.rows.length
  }), isEditable && /*#__PURE__*/_react.default.createElement(_TableControls.TableControls, {
    onSaveHandler: onSaveHandler,
    onResetHandler: onResetHandler
  })));
};
exports.Table = Table;
Table.propTypes = {
  tableId: _propTypes.default.string,
  columns: _TableProps.TableColumnDefinitionArrayProp,
  // eslint-disable-next-line react/forbid-prop-types
  data: _propTypes.default.arrayOf(_propTypes.default.any),
  // eslint-disable-next-line react/forbid-prop-types,
  pageSize: _propTypes.default.number,
  // eslint-disable-next-line react/forbid-prop-types,
  hookFormMethods: _propTypes.default.any,
  isEditable: _propTypes.default.bool,
  customFooter: _propTypes.default.element,
  isInitialised: _propTypes.default.bool,
  inlineEditing: _propTypes.default.bool,
  enableGrouping: _propTypes.default.bool,
  showRowSelectors: _propTypes.default.bool,
  onEditHandler: _propTypes.default.func,
  onDeleteHandler: _propTypes.default.func,
  onInitHandler: _propTypes.default.func,
  onSaveHandler: _propTypes.default.func,
  onUpdateHandler: _propTypes.default.func,
  onResetHandler: _propTypes.default.func,
  // eslint-disable-next-line react/forbid-prop-types
  skipReset: _propTypes.default.any
};
var _default = exports.default = Table;